
<mat-dialog-content>
    <h4>Notepad</h4>
    <div style="width: 100%">
        <ckeditor style="max-width: 100%"
            #noteEditor

            [editor]="Editor"
            [config]="ckEditorConfig"
            [formControl]="noteDescription"

        ></ckeditor>
        <p></p>
        <svg class="demo-update__chart" viewbox="0 0 40 40" width="40" height="40" xmlns="http://www.w3.org/2000/svg">
          <circle stroke="hsl(0, 0%, 93%)" stroke-width="3" fill="none" cx="20" cy="20" r="17" />
          <circle class="demo-update__chart__circle" stroke="hsl(202, 92%, 59%)" stroke-width="3" stroke-dasharray="134,534" stroke-linecap="round" fill="none" cx="20" cy="20" r="17" />
          <text class="demo-update__chart__characters" x="50%" y="50%" dominant-baseline="central" text-anchor="middle"></text>
      </svg>
      </div>
</mat-dialog-content>
<mat-dialog-actions class="snippet-dialog-action-btn" style="float: right;">
<button mat-raised-button class="btn btn-save demo-update__send" mat-dialog-close (click)="saveNote()" [disabled]="disabledButton" >Save</button>
</mat-dialog-actions>
